import { inject } from '@angular/core';
import { ResolveFn, ActivatedRouteSnapshot } from '@angular/router';
import { forkJoin, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { BlogPostService, PostTypeService, PaginatedResponse, BlogPostPopulated, PostTypeListResponse } from 'cms-post-lib';
import { environment } from '../../../environments/environment';

export interface PostListResolverData {
  posts: PaginatedResponse<BlogPostPopulated>;
  postTypes: PostTypeListResponse;
}

export const postListResolver: ResolveFn<PostListResolverData> = (route: ActivatedRouteSnapshot) => {
  const blogPostService = inject(BlogPostService);
  const postTypeService = inject(PostTypeService);
  const orgId = environment.orgId;

  // Resolve initial query params from route
  const search = route.queryParamMap.get('search') ?? undefined;
  const tagsParam = route.queryParamMap.getAll('tags');
  const tags = tagsParam.length ? tagsParam : undefined;
  const page = parseInt(route.queryParamMap.get('page') ?? '1', 10);

  return forkJoin({
    postTypes: postTypeService.getPublicPostTypes(orgId).pipe(
      catchError(() => of({ success: false, count: 0, data: [] } as PostTypeListResponse))
    ),
    posts: blogPostService.getPublicBlogPosts({ orgId, search, tags, page, limit: 12 }).pipe(
      catchError(() => of({
        success: false,
        count: 0,
        data: [],
        pagination: { page: 1, limit: 12, total: 0, pages: 0 }
      } as PaginatedResponse<BlogPostPopulated>))
    )
  });
};
